import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * 设置选择前的方法，获取选择文件的相关信息，需要时可以对图片进行压缩、改变图片尺寸。
 *
 * multiple: 默认为 false，设置为 true 之后一次可以选择多张，onChange 事件调用之后返回一个数组，
 *           不设置或者设置为 false，onChange 事件调用之后返回一个对象。
 * disabled: 传递之后不可以点击上传，整个选择组件会设置为半透明状态，透明度为 0.5。
 * quality: 没有默认值，不设置不会进行压缩。
 * accept: 设置选择的文件类型，默认为所有类型，只有文件类型为图片（image/*）的时候会有本地预览图。
 * onChange: () => { file, fileType, fileSize, fileName, thumbnail }。
 * onBeforeSelect: () => boolean，返回 false 的时候阻止后续的选择事件。
 */
import React, { PureComponent, cloneElement } from 'react';
import classNames from 'classnames';
import handleFileInfo from './utils/handleFileInfo';

var FilePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits(FilePicker, _PureComponent);

  var _super = _createSuper(FilePicker);

  function FilePicker() {
    var _this;

    _classCallCheck(this, FilePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.file = null;

    _this.handleDefaultInput = function (e) {
      // 防止选择同一张图片两次造成 onChange 事件不触发
      e.currentTarget.value = '';
      var _this$props = _this.props,
          onBeforeSelect = _this$props.onBeforeSelect,
          disabled = _this$props.disabled;

      if (typeof onBeforeSelect !== 'function') {
        return;
      } // 阻止 input onChange 默认事件


      if (onBeforeSelect() === false || disabled) {
        e.preventDefault();
      }
    };

    _this.handleClick = function () {
      _this.file.click();
    };

    _this.handleChange = function (e) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          quality = _this$props2.quality,
          multiple = _this$props2.multiple;
      var files = [].slice.call(e.target.files);
      var fileList = [];

      var getFileInfo = function getFileInfo(data) {
        if (multiple) {
          fileList.push(data);

          if (files.length === fileList.length && typeof onChange === 'function') {
            onChange(fileList);
          }
        } else {
          typeof onChange === 'function' && onChange(data);
        }
      };

      if (files) {
        files.map(function (file) {
          return handleFileInfo({
            file: file,
            quality: quality
          }, getFileInfo);
        });
      }
    };

    return _this;
  }

  _createClass(FilePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          className = _this$props3.className,
          multiple = _this$props3.multiple,
          accept = _this$props3.accept,
          capture = _this$props3.capture,
          disabled = _this$props3.disabled,
          children = _this$props3.children;
      var cls = classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "--disabled"), disabled));
      var content = /*#__PURE__*/cloneElement(children, {
        onClick: this.handleClick,
        className: classNames(children.props.className, 'needsclick') // 修复加载fastClick库后引起的合成事件问题

      });
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, /*#__PURE__*/React.createElement("input", {
        className: "".concat(prefixCls, "__input"),
        type: "file",
        ref: function ref(ele) {
          _this2.file = ele;
        },
        accept: accept,
        multiple: multiple,
        capture: capture,
        onClick: this.handleDefaultInput,
        onChange: this.handleChange
      }), content);
    }
  }]);

  return FilePicker;
}(PureComponent);

FilePicker.defaultProps = {
  prefixCls: 'za-file-picker',
  disabled: false,
  multiple: false,
  onBeforeSelect: function onBeforeSelect() {
    return true;
  }
};
export { FilePicker as default };